/**
 * @flow
 * @relayHash ea96e20637c139ad3c44411f5eae3a2f
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SupplierCategoryCreateInput = {|
  name: string
|};
export type CreateSupplierCategoryMutationVariables = {|
  data: SupplierCategoryCreateInput
|};
export type CreateSupplierCategoryMutationResponse = {|
  +createSupplierCategory: {|
    +id: string
  |}
|};
export type CreateSupplierCategoryMutation = {|
  variables: CreateSupplierCategoryMutationVariables,
  response: CreateSupplierCategoryMutationResponse,
|};
*/


/*
mutation CreateSupplierCategoryMutation(
  $data: SupplierCategoryCreateInput!
) {
  createSupplierCategory(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "SupplierCategoryCreateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createSupplierCategory",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "SupplierCategoryModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreateSupplierCategoryMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreateSupplierCategoryMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreateSupplierCategoryMutation",
    "id": null,
    "text": "mutation CreateSupplierCategoryMutation(\n  $data: SupplierCategoryCreateInput!\n) {\n  createSupplierCategory(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f49107434de8cd42485464a549e0e434';
module.exports = node;
